/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./OrgSetupKyc.css";
import PropTypes from "prop-types";
import { simpleFetch } from "../../../restWrapper";
import { PLATFORM } from "../../../config";
import { getApiErrorMessage } from "../../../assets/errorMessages.js";

class OrgSetupKyc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: null,
    };
    this.fetchKycData = this.fetchKycData.bind(this);
  }

  componentDidMount() {
    this.fetchKycData();
  }

  fetchKycData() {
    this.setState({ loading: true, error: null });

    simpleFetch("/organizations", "GET", {})
      .then((res) => {
        if (res.status !== 200) {
          throw new Error(getApiErrorMessage(res, "zh"));
        }

        /* Get organization type */
        const organizationType =
          res.body.organizationObj.organizationType || "nonprofit";

        /* Get Stripe KYC Link and KYC Status - pass organization type explicitly */
        simpleFetch(
          `/organizations/setupAccountLink?organizationType=${organizationType}`,
          "GET",
        )
          .then((kycRes) => {
            // console.log(JSON.stringify(kycRes.body) + " -27");
            if (kycRes.status !== 200) {
              const errorMsg =
                kycRes.body?.message ||
                "Failed to load KYC verification link. Please try again.";
              this.setState({
                loading: false,
                error: errorMsg,
                organizationType: organizationType,
              });
              return;
            }

            if (kycRes.body.url) {
              this.setState({
                stripeAccountLink: kycRes.body.url,
                currently_due: kycRes.body.currently_due,
                organizationType: organizationType,
                loading: false,
                error: null,
              });
            } else {
              this.setState({
                loading: false,
                organizationType: organizationType,
              });
            }
          })
          .catch((err) => {
            this.setState({
              loading: false,
              error:
                "Failed to load KYC verification link. Please check your connection and try again.",
              organizationType: organizationType,
            });
          });

        if (res.body.organizationObj.completedSetup) this.props.nextBtn();
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error:
            err.message ||
            "Failed to load organization data. Please try again.",
        });
      });
  }
  render() {
    if (this.state.loading) {
      return <this.props.RenderFullPageLoading />;
    }


    const nextBtn = () => {
      simpleFetch("/organizations", "PUT", {
        completedSetup: true,
      });
      this.props.nextBtn();
    };

    return (
      <div className="OrgSetupKyc-view">
        <div className="OrgSetupKyc-center">
          <div className="OrgSetupKyc-header">
            {/* Conditionally render logo based on platform */}
            <div
              className={
                PLATFORM === "plug"
                  ? "OrgSetupKyc-PlugLogo"
                  : "OrgSetupKyc-CheckPlusLogo"
              }
            />

            <div className="OrgSetupKyc-headerBottom">
              <div className="OrgSetupKyc-backBtn" onClick={this.props.backBtn}>
                <div className="OrgSetupKyc-backIcn" />
              </div>

              <div className="OrgSetupKyc-steps">
                {this.props.languageObj.step}
              </div>
            </div>
          </div>

          <div className="OrgSetupKyc-body">
            <div className="OrgSetupKyc-text">
              {PLATFORM === "plug" ? "Plug" : "CheckPlus"} partners with Stripe
              for secure financial services.
              {this.state.organizationType === "business"
                ? " As a business, you need to complete KYC verification to process payments."
                : " As a nonprofit, you need to complete KYC verification to receive donations."}
            </div>
            {this.state.stripeAccountLink &&
            this.state.currently_due.length !== 0 ? (
                <a href={this.state.stripeAccountLink}>
                  <div className="OrgSetupKyc-kycBtn">
                    <div className="OrgSetupKyc-kycInnerGroup">
                      <span className="OrgSetupKyc-kycTxt">Verify KYC via</span>
                      <span className="OrgSetupKyc-stripeLogo" />
                    </div>
                  </div>
                </a>
              ) : null}

            {this.state.stripeAccountLink &&
            this.state.currently_due.length === 0 ? (
                <div className="OrgSetupKyc-kycCompleteBtn">
                  <div className="OrgSetupKyc-kycInnerGroup">
                    <span className="OrgSetupKyc-completedIcn" />
                    <span className="OrgSetupKyc-kycTxt">KYC Complete</span>
                  </div>
                </div>
              ) : null}

            {this.state.error ? (
              <div>
                <div className="OrgSetupKyc-errorMsg">{this.state.error}</div>
                <div
                  className="OrgSetupKyc-kycBtn"
                  onClick={this.fetchKycData}
                  style={{ cursor: "pointer" }}
                >
                  <div className="OrgSetupKyc-kycInnerGroup">
                    <span className="OrgSetupKyc-kycTxt">Retry</span>
                  </div>
                </div>
              </div>
            ) : !this.state.stripeAccountLink ? (
              <div className="OrgSetupKyc-kycBtnGrey">
                <div className="OrgSetupKyc-kycTxtGrey">Loading...</div>
              </div>
            ) : null}

            <div
              className="OrgSetupKyc-logoutTxt"
              onClick={this.props.orgLogout}
            >
              {this.props.languageObj.rightBtn}
            </div>

            {/* CP-304: KYC / bank payouts can be deferred. A nonprofit that
                signed up on Plug can publish impact before Stripe is ready. */}
            <div
              className="OrgSetupKyc-logoutTxt"
              onClick={this.props.skipPaymentsBtn || nextBtn}
              style={{ marginTop: 8, cursor: "pointer" }}
            >
              {(this.props.languageObj &&
                this.props.languageObj.setupPaymentsLater) ||
                "Set up payments later"}
            </div>

            {this.state.stripeAccountLink &&
            this.state.currently_due.length === 0 ? (
                <div className="OrgSetupKyc-nextBtn" onClick={nextBtn}>
                  <div className="OrgSetupKyc-nextIcnContainer">
                    <div className="OrgSetupKyc-nextIcn" />
                  </div>

                  <div className="OrgSetupKyc-nextText">Finish setup</div>
                </div>
              ) : (
                <div className="OrgSetupKyc-nextBtnGray">
                  <div className="OrgSetupKyc-nextIcnContainerGray">
                    <div className="OrgSetupKyc-nextIcnGray" />
                  </div>

                  <div className="OrgSetupKyc-nextTextGray">Finish setup</div>
                </div>
              )}
          </div>
        </div>
      </div>
    );
  }
}

OrgSetupKyc.propTypes = {
  RenderFullPageLoading: PropTypes.func,
  backBtn: PropTypes.func,
  nextBtn: PropTypes.func,
  skipPaymentsBtn: PropTypes.func,
  orgLogout: PropTypes.func,
  languageObj: PropTypes.object,
};

export default OrgSetupKyc;
